<template>
    <div class="services container-fluid h-100 pt-3">
        <div class="row h-100 m-0">
            <div class="col-lg-7 col-xl-8 h-100 overflow-auto">
                <div class="position-sticky title d-flex justify-content-between align-items-center mb-2">
                    <div class="d-flex align-items-center">
                        <h1 class="font-weight-bolder col pl-xl-0 mb-0">
                            服務項目
                        </h1>
                    </div>
                    <div class="d-flex align-items-center">
                        <button class="btn btn-light rounded-pill shadow-sm text-nowrap mr-2"
                                v-on:click="isModalCategoriesOpen = true">
                            <font-awesome-icon class="mr-2"
                                               icon="tags">
                            </font-awesome-icon>服務分類
                        </button>
                        <button class="btn btn-light rounded-pill shadow-sm text-nowrap"
                                v-on:click="isAddServiceModalOpen = true">
                            <font-awesome-icon class="mr-2"
                                               icon="plus-square">
                            </font-awesome-icon>新增服務
                        </button>
                    </div>
                </div>

                <div class="position-sticky service-list-heading pt-1 pb-3">
                    <search-bar class="search-bar"
                                has-filter
                                v-model="keyword">
                    </search-bar>
                </div>

                <div v-if="services.length === 0">
                    <h5 class="text-center font-weight-normal mb-4">
                        No service
                    </h5>
                </div>

                <div class="row">
                    <service-card class="col-md-6 col-lg-12 col-xl-6 px-2 px-md-3"
                                  v-for="service in services"
                                  v-bind:key="service._id"
                                  v-bind:service="service">
                    </service-card>
                </div>
            </div>

            <div class="col-lg-5 col-xl-4 mx-3 mx-lg-0 p-lg-0">
                <router-view></router-view>
            </div>
        </div>

        <modal-service v-model="isAddServiceModalOpen"></modal-service>
        <modal-categories v-model="isModalCategoriesOpen"></modal-categories>
    </div>
</template>

<script>
import ServiceCard from "../components/Services/ServiceCard";
import ModalService from "../components/Services/ModalService";
import SearchBar from "../components/Users/SearchBar";
import ModalCategories from "../components/Services/ModalCategories";

export default {
    name: "Services",
    components: {
        ModalCategories,
        SearchBar,
        ModalService,
        ServiceCard
    },
    data () {
        return {
            isAddServiceModalOpen: false,
            isModalCategoriesOpen: false,
            keyword: "",
        };
    },
    computed: {
        services () {
            return this.$store.state.data.services;
        },
    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
.title {
    top: 0;
    z-index: 3;
}

.service-list-heading {
    top: 52px;
    z-index: 3;
}
</style>
